import { parseResponsiveProperty } from '@converdy/styles'


const alignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end'
}


export default function responsiveAlignment(alignment = {}) {

  let jss = {}

  jss = parseResponsiveProperty(a => {
    return a ? {
      display: 'flex',
      justifyContent: alignmentMap[a]
    } : {} 
  }, alignment)

  return jss

}


export function responsiveTextAlignment(alignment = {}) {

  let jss = {}

  jss = parseResponsiveProperty(a => {
    return a ? {
      textAlign: a,
    } : {} 
  }, alignment)

  return jss

}
